import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const Sizing = ({ sizing, product }) => ((sizing && sizing.length > 0) ? (
  <ProductPropertyTab title="Size / Fit" product={product}>
    <PropertyList element="ul" like="dec-4">
      {
          sizing.map((item) =>
            // eslint-disable-next-line react/no-danger
            <li key={item.id} dangerouslySetInnerHTML={{ __html: item.value }} />)
        }
    </PropertyList>
  </ProductPropertyTab>
) : null);

Sizing.defaultProps = {
  sizing: []
};

Sizing.propTypes = {
  product: PropTypes.object.isRequired,
  sizing: PropTypes.array
};

export default Sizing;
